import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { MdRemove, MdAdd, MdSave, MdDeleteOutline } from "react-icons/md";
import { LoadingButton } from '@mui/lab';
import { grey } from '@mui/material/colors';
import { n_format } from '../../n_format';
import {
    Table, TableBody, TableCell, TableHead,
    TableRow, Button, IconButton, Typography, Dialog, DialogTitle, Alert,
    DialogActions, DialogContent, Grid, Snackbar, useMediaQuery, ImageList, Avatar
} from '@mui/material';

const getRandomColor = (index) => {
    const hue = (index * 137) % 360; // 137 = golden angle for max separation
    return `hsl(${hue}, 70%, 60%)`;   // vibrant colors
};

const AppCRUD = () => {
    const [snackbar, set_snackbar] = useState(false);
    const [categories, set_categories] = useState([]);
    const [category_id, set_category_id] = useState([]);
    const [product, set_product] = useState([]);
    const [products, set_products] = useState([]);
    const [qte, set_qte] = useState('1');
    const is_sm = useMediaQuery("(max-width:600px)");
    const [dialog_edit_is_open, set_dialog_edit_is_open] = useState(false);
    const [dialog_item, set_dialog_item] = useState({});
    const [edit_loading, set_edit_loading] = useState(false);
    const company = JSON.parse(localStorage.getItem("company"));

    {// Permissions
        const [permissions, set_permissions] = useState([]);
        useEffect(() => {
            axios
                .post(`${process.env.REACT_APP_API_URL}permissions?route=datamanaging/pos`)
                .then((res) => {
                    set_permissions(res?.data)
                    if (res?.data?.length == 0) {
                        localStorage.removeItem('accessToken');
                        window.history.replaceState(null, null, "/login")
                        location.pathname = '/login';
                        window.location.href = "/login";
                    }
                })
                .catch(() => console.log('error!'))
        }, [])
    }

    useEffect(() => {
        if (dialog_edit_is_open) set_qte('1')
    }, [dialog_edit_is_open])

    useEffect(() => {
        set_dialog_item(d => ({
            ...d,
            products: (d?.products || []).map(p => ({
                ...p,
                total: (p?.product?.price || 0) * (p?.qte || 0)
            })),
            total: (dialog_item?.products || []).reduce((sum, p) => sum + (p?.total || 0), 0)
        }));
    }, [dialog_item?.products])

    useEffect(() => {
        load_categories()
        load_products()
    }, [])

    const load_categories = async () => {
        await axios
            .post(`${process.env.REACT_APP_API_URL}categories`, {
                per_page: 200,
            })
            .then((res) => {
                try {
                    set_category_id(res?.data?.data?.[0]?.id);
                    set_categories(res?.data?.data);
                } catch (error) {
                    set_snackbar({ message: error?.message ?? 'Error ! Categories' });
                }
            })
            .catch((err) => set_snackbar({ message: 'Error ! Chargement de donnees' }));
    };

    const load_products = async () => {
        await axios
            .post(`${process.env.REACT_APP_API_URL}products`, {
                per_page: 2000,
                filters: {
                    'type': 'PV',
                }
            })
            .then((res) => {
                try {
                    set_products(res?.data?.data);
                } catch (error) {
                    set_snackbar({ message: error?.message ?? 'Error ! Products' });
                }
            })
            .catch((err) => set_snackbar({ message: 'Error ! Chargement de donnees' }));
    };

    const save_data = async () => {
        set_edit_loading(true)
        console.log(dialog_item?.products?.map((p) => ({ product_id: p?.product?.id, qte: p?.qte })));

        await axios
            .post(`${process.env.REACT_APP_API_URL}orders_store`, {
                products: dialog_item?.products?.map((p) => ({ product_id: p?.product?.id, qte: p?.qte })),
                status_id: 120,
                type: 10,
                company_id: company?.id,
                // "name_client": "test",
                // "phone": "test",
                // "notes": "",
                // "neighborhood_id": null,
            })
            .then((res) => {
                set_dialog_item({})
                set_snackbar({ message: 'Order successfully created!', type: 'success' });
            })
            .catch((err) => set_snackbar({ message: 'Error ! Chargement de donnees' }));
        set_edit_loading(false)

    };

    return (
        <Grid height={{ xs: '100%', sm: "85vh" }} sx={{ border: 0, borderColor: 'red', pl: 2, pt: 2 }}>
            {/* <MainCard title="Caisse" sx={{ p: 0, m: 0 }} contentSX={{ p: 0, m: 0 }}> */}
            <Snackbar
                open={snackbar ? true : false}
                autoHideDuration={snackbar?.hide_duration ?? 3000}
                onClose={() => { set_snackbar(false); }}
            >
                <Alert
                    onClose={() => { set_snackbar(false); }}
                    severity={snackbar?.type ?? 'error'} // success error warning info
                    sx={{ width: '100%' }}
                >
                    {snackbar?.message}
                </Alert>
            </Snackbar>
            <Grid height='100%' container spacing={2} alignItems="center">
                <Grid height='100%' xs={12} sm={4} sx={{ border: 0, pr: 1 }}>
                    <Grid container direction="column" sx={{ height: "100%" }}>
                        <Grid item sx={{ height: "80%", overflowY: "auto" }}>
                            <Table stickyHeader>
                                <TableHead>
                                    <TableRow>
                                        <TableCell sx={{ py: 0.5, backgroundColor: grey[200] }} align="left">Nom</TableCell>
                                        <TableCell sx={{ py: 0.5, backgroundColor: grey[200] }} align="center">Quantité</TableCell>
                                        <TableCell sx={{ py: 0.5, backgroundColor: grey[200] }} align="right">Total</TableCell>
                                        <TableCell sx={{ py: 0.5, backgroundColor: grey[200] }} align="right"></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {Object.values(dialog_item?.products ?? []).map((d, index) => (
                                        <TableRow key={index} sx={{ backgroundColor: (index % 2) ? grey[100] : '' }}>
                                            <TableCell sx={{ py: 0.5 }} align="left">{d?.product?.name}</TableCell>
                                            <TableCell sx={{ py: 0.5 }} align="center">
                                                <Grid container justifyContent="space-between">
                                                    <Grid>
                                                        <IconButton color="primary" onClick={() => set_dialog_item(d => ({ ...d, products: (d.products || []).map((p, i) => i == index ? { ...p, qte: (Number(p.qte) || 0) + 1 } : p) }))}>
                                                            <MdAdd />
                                                        </IconButton>
                                                    </Grid>
                                                    <Grid>
                                                        <Typography sx={{ pt: 1 }}>{d?.qte}</Typography>
                                                    </Grid>
                                                    <Grid>
                                                        <IconButton color="error" onClick={() => set_dialog_item(d => ({ ...d, products: (d.products || []).map((p, i) => i == index ? { ...p, qte: Math.max((p.qte || 1) - 1, 1) } : p) }))}>
                                                            <MdRemove />
                                                        </IconButton>
                                                    </Grid>
                                                </Grid>
                                            </TableCell>
                                            <TableCell sx={{ py: 0.5 }} align="right">{d?.total} DH</TableCell>
                                            <TableCell sx={{ py: 0.5 }} align="right">
                                                <IconButton color="error" sx={{ p: 0, m: 0 }} onClick={() => set_dialog_item(d => ({ ...d, products: d.products?.filter((_, i) => i != index) }))}>
                                                    <MdDeleteOutline />
                                                </IconButton>
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </Grid>
                        <Grid item container sx={{ height: "12%", borderTop: 1, borderColor: grey[400], py: 1, px: 3 }}>
                            <Grid xs={6}>
                                <Typography sx={{ textAlign: "left", fontWeight: 'bold', fontSize: "2rem" }}>TOTAL</Typography>
                            </Grid>
                            <Grid xs={6}>
                                <Typography sx={{ textAlign: "right", fontWeight: 'bold', fontSize: "2rem" }}>{n_format(dialog_item?.total, 2, ' ', ',')} DH</Typography>
                            </Grid>
                        </Grid>
                        <Grid item sx={{ height: "8%", borderTop: 1, borderColor: grey[400], py: 1, px: 3 }}>
                            {/* <LoadingButton
                                color="primary"
                                loadingPosition="start"
                                startIcon={<MdSave />}
                                variant="contained"
                                onClick={() => {
                                    set_dialog_item(d => ({
                                        ...d,
                                        products: [
                                            ...(d.products || []),
                                            {
                                                product: product,
                                                qte: qte
                                            }
                                        ]
                                    })),
                                        set_dialog_edit_is_open(false)
                                }}
                            >
                                Ok
                            </LoadingButton> */}

                            <LoadingButton loading={edit_loading} variant="contained" color="primary" sx={{ width: '100%' }} onClick={() => save_data()}>
                                Valider la commande{edit_loading && '...'}
                            </LoadingButton>
                        </Grid>
                    </Grid>
                    {/* Left side content */}
                </Grid>
                <Grid height='100%' xs={12} sm={8} sx={{ border: 1 }}>
                    <Grid item sx={{ py: 0, px: 2 }}>
                        <ImageList cols={is_sm ? 2 : 8} gap={10}>
                            {(categories ?? []).map((c, i) => (
                                <Grid item xs={12} sx={{ py: 0, px: 0, border: 1 }} onClick={() => set_category_id(c?.id)}>
                                    {c?.image ? (
                                        <img
                                            src={process.env.REACT_APP_URL + 'storage/' + c?.image}
                                            alt={c?.name}
                                            loading="lazy"
                                        />
                                    ) : (
                                        // <Stack direction="row" >
                                        <Avatar variant="square" sx={{ width: '100%', height: { xs: 50, sm: 50 }, backgroundColor: getRandomColor(i), }}>
                                            {c?.name?.substring(0, 9).charAt(0).toUpperCase() + c?.name?.substring(1, 9).toLowerCase() + (c?.name?.substring(9, 20) ? '..' : '')}
                                        </Avatar>
                                        // </Stack>
                                    )}
                                </Grid>
                                // <Avatar variant="square" sx={{ width: 100, height: { xs: 100, sm: 100 }, backgroundColor: getRandomColor(i), }}>
                                //     {c?.name.charAt(0).toUpperCase()}
                                // </Avatar>
                                // <ImageListItem key={c?.name} onClick={(e, v) => { setCategory(c), load_products1([['products.company_id', 'in', c?.company_ids], ['category_id', 'in', c?.ids], ['products.type', 'in', ['PF', 'PA']]]) }}>
                                //     {c?.image ? (
                                //         <img
                                //             src={process.env.REACT_APP_URL + 'storage/' + c?.image}
                                //             alt={c?.name}
                                //             loading="lazy"
                                //         />
                                //     ) : (
                                //         // <Stack direction="row" >
                                //             <Avatar variant="square" sx={{ width: '100%', height: { xs: 50, sm: 50 }, backgroundColor: getRandomColor(i), }}>
                                //                 {c?.name.charAt(0).toUpperCase()}
                                //             </Avatar>
                                //         // </Stack>
                                //     )}
                                //     <ImageListItemBar title={c?.name} />
                                // </ImageListItem>
                            ))}
                        </ImageList>
                    </Grid>
                    <Grid item container sx={{ p: 1, borderTop: 1 }}>
                        {(products ?? [])?.filter(p => p?.category_id == category_id).map((c, i) => (
                            <Grid item xs={2} sx={{ p: 0.3, border: 0, width: '100%', height: { xs: 70, sm: 70 } }}
                                onClick={() => { set_dialog_edit_is_open(true), set_product(c) }}>
                                {c?.image && false ? (
                                    <img
                                        src={process.env.REACT_APP_URL + 'storage/' + c?.image}
                                        alt={c?.name}
                                        loading="lazy"
                                        height='100%'
                                        width='100%'
                                    />
                                ) : (
                                    // <Stack direction="row" >
                                    <Avatar variant="square" sx={{ width: '100%', height: '100%', backgroundColor: getRandomColor(i) }}>
                                        {c?.name?.substring(0, 10).charAt(0).toUpperCase() + c?.name?.substring(1, 10).toLowerCase()}
                                    </Avatar>
                                    // </Stack>
                                )}
                            </Grid>
                        ))}
                    </Grid>
                </Grid>
            </Grid>
            {/* </MainCard> */}
            <Dialog
                open={dialog_edit_is_open}
                onClose={() => { set_dialog_edit_is_open(false) }}
                maxWidth="xs"
            // fullScreen
            >
                <DialogTitle id="dialog1-title">Quantité</DialogTitle>
                <DialogContent dividers>
                    <Grid alignItems="center" justify="center">
                        <Grid container xs={12} sm={12} sx={{ ml: 0 }}>
                            <Button
                                variant="outlined"
                                color="secondary"
                                fullWidth
                                sx={{ py: 2, fontSize: '20px', mb: 2 }}
                                onClick={() => set_dialog_item(o1 => ({
                                    ...o1,
                                    operation_details: Object.values(o1.operation_details ?? []).map((p, pi) => pi == odi ? { ...p, product1_qte: '' } : p)
                                }))
                                }
                            >
                                <Typography color='#000' fontSize={20}>{qte}</Typography>
                            </Button>
                            <Grid item container spacing={1}>
                                {[1, 2, 3, 4, 5, 6, 7, 8, 9, '<=', 0, 'C'].map((num, index) => (
                                    <Grid item xs={4} key={index}>
                                        {num !== '' ? (
                                            <>
                                                {num == 'C' || num == '<=' ? (
                                                    <>
                                                        {num == '<=' ? (
                                                            <Button
                                                                variant="outlined"
                                                                fullWidth
                                                                color="warning"
                                                                sx={{ py: 2, fontSize: '20px' }}
                                                                onClick={() => set_qte(qte?.toString()?.slice(0, -1))}
                                                            >
                                                                {num}
                                                            </Button>
                                                        ) : (
                                                            <Button
                                                                variant="outlined"
                                                                color="error"
                                                                fullWidth
                                                                sx={{ py: 2, fontSize: '20px' }}
                                                                onClick={() => set_qte('1')}
                                                            >
                                                                {num}
                                                            </Button>
                                                        )}
                                                    </>
                                                ) : (
                                                    <Button
                                                        variant="outlined"
                                                        fullWidth
                                                        sx={{ py: 2, fontSize: '20px' }}
                                                        onClick={() => set_qte((qte == '1' ? '' : qte) + num.toString())}
                                                    >
                                                        {num}
                                                    </Button>
                                                )}
                                            </>
                                        ) : (
                                            <div style={{ height: '48px' }} />
                                        )}
                                    </Grid>
                                ))}
                            </Grid>
                        </Grid>
                    </Grid>
                </DialogContent>

                <DialogActions>
                    {!edit_loading && <Button onClick={() => set_dialog_edit_is_open(false)}>Cancel</Button>}
                    <LoadingButton
                        color="primary"
                        loadingPosition="start"
                        startIcon={<MdSave />}
                        variant="contained"
                        onClick={() => {
                            set_dialog_item(d => ({
                                ...d,
                                products: [
                                    ...(d.products || []),
                                    {
                                        product: product,
                                        qte: qte
                                    }
                                ]
                            })),
                                set_dialog_edit_is_open(false)
                        }}
                    >
                        Ok
                    </LoadingButton>
                </DialogActions>

            </Dialog>
        </Grid >
    );
};

export default AppCRUD;
